import { render, staticRenderFns } from "./Surface.vue?vue&type=template&id=8bb63b1e&scoped=true&"
import script from "./Surface.vue?vue&type=script&lang=js&"
export * from "./Surface.vue?vue&type=script&lang=js&"
import style0 from "./Surface.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Surface.vue?vue&type=style&index=1&id=8bb63b1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb63b1e",
  null
  
)

export default component.exports